import { createColumnHelper } from '@tanstack/react-table';

import { formatIsoDate } from '@/utils/date';

import NameCell from './NameCell';
import ActionsCell from './ActionsCell';

import type { ApiKeyResponse } from './types';

const columnHelper = createColumnHelper<ApiKeyResponse>();

export const apiKeysColumns = [
  columnHelper.accessor('name', {
    header: 'Name',
    cell: NameCell,
    size: 200,
  }),
  columnHelper.accessor('created_at', {
    header: 'Created',
    cell: ({ getValue }) => formatIsoDate(getValue()),
    size: 200,
  }),
  columnHelper.accessor('last_used', {
    header: 'Last Used',
    cell: ({ getValue }) => {
      const value = getValue();
      return value ? formatIsoDate(value) : '-';
    },
    size: 200,
  }),
  columnHelper.display({
    id: 'actions',
    header: '',
    cell: ActionsCell,
    meta: {
      alignment: 'center',
    },
  }),
];
